var render = function render(){var _vm=this,_c=_vm._self._c;return _c('awesome-table',{attrs:{"items":_vm.tags,"labels":['name'],"options":{
        filters: false,
        sort: false,
        addButton: false,
        link: false,
        searchInput: false,
        isCard: false
    },"pagination":_vm.pagination},on:{"row-click":_vm.onRowClick,"pagination-change":_vm.onPaginationChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }